import { render, staticRenderFns } from "./NotifyLayout.vue?vue&type=template&id=84a5c1c4&scoped=true"
import script from "./NotifyLayout.vue?vue&type=script&lang=js"
export * from "./NotifyLayout.vue?vue&type=script&lang=js"
import style0 from "./NotifyLayout.vue?vue&type=style&index=0&id=84a5c1c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5c1c4",
  null
  
)

export default component.exports